// removed by extract-text-webpack-plugin
module.exports = {"heading":"jSpy_dLYoB hdg","strong":"_3OfzWmf-Qf","paymentTAndC":"_2ld31wh_XN"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/public/legal/PaymentTermsAndConditions/PaymentTermsAndConditions.module.less
// module id = 480
// module chunks = 3